<template>
    <b-container fluid id="layout_header_component" class="layout-header-component">
        <middlebar></middlebar>
        <bottombar v-if="!menuOpen"></bottombar>
    </b-container>
</template>

<script>
    import Topbar from './header/Topbar.vue'
    import Middlebar from './header/Middlebar.vue'
    import Bottombar from './header/Bottombar.vue'

    export default {
        components: { Topbar, Middlebar, Bottombar },
        computed: {
            menuOpen () {
                return this.$store.getters.mobileMenu
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/LayoutHeader.vue